import _ from 'lodash';
import { DataDirection } from '../../../core/types/ui/position';
import {
  calculateSectionHeightHelper,
  calculateSectionWidthHelper,
} from '../../../sections/utils';
import { WindowSizes } from '../../../windows/constants/windowSizes';
import { SheetDefaults } from '../../constants/sheetDefaults';
import {
  Col,
  EntitySize,
  FilterResults,
  Freeze,
  IRange,
  Row,
  SelectionCell,
  Sheet,
  SheetSelection,
  SheetView,
  Viewport,
} from '../../types';
import { getDefaultArea, getDefaultPosition } from '../area/area';
import { getRowHeaderWidth } from '../sheet/uiData';
import {
  getDefaultVirtualViewport,
  getFreezeBarHandleSize,
} from '../viewport/viewportUtils';
import { Boundaries } from './moveSelection';
import { getUnHiddenPosition, getViewportStartEnd } from './virtualViewport';
import { testFilterResults } from '../sheet/testData';

export const defaultFilterResults = (): FilterResults => ({
  startRow: -1,
  hasFilter: false,
  rowsIndexes: [],
  filterIndexesMap: {},
  lastRow: -1,

  // hasFilter: false,
  // rowsIndexes: [],
  // filterIndexesMap: {},
  // lastRow: -1,

  // ...testFilterResults,

  // hasFilter: true,
  // rowsIndexes: [0, 1, 4, 99908],
  // filterIndexesMap: {
  //   0: 0,
  //   1: 1,
  //   4: 2,
  //   99908: 3,
  // },
  // lastRow: 99909,

  // hasFilter: true,
  // rowsIndexes: [],
  // filterIndexesMap: {},
  // lastRow: 99909,

  // hasFilter: true,
  // rowsIndexes: [1, 99, 199, 299, 399],
  // filterIndexesMap: {
  //   1: 0,
  //   99: 1,
  //   199: 2,
  //   299: 3,
  //   399: 4
  // },
  // lastRow: 950,

  // hasFilter: true,
  // rowsIndexes: [14, 15,],
  // filterIndexesMap: {14: 0, 15: 1,  },
  // lastRow: 30,

  // hasFilter: true,
  // rowsIndexes: [2, 4, 6],
  // filterIndexesMap: { 2: 0, 4: 1, 6: 2 },
  // lastRow: 10,

  // hasFilter: true,
  // rowsIndexes: [2, 4, 6, 8, 9, 10],
  // filterIndexesMap: {
  //   2: 0,
  //   4: 1,
  //   6: 2,
  //   9: 3,
  //   10: 4,
  // },
  // lastRow: 15,
});

export const createSheetDefaultView = (
  view?: Partial<SheetView>
): SheetView => {
  const basicSelection: SheetSelection = {
    area: getDefaultArea(),
    cell: SelectionCell.Cell,
  };
  return {
    activeCellArea: getDefaultArea(),
    activeCell: getDefaultPosition(),
    selections: [basicSelection],
    // viewport: getDefaultViewport(),
    rowViewport: getDefaultVirtualViewport(),
    colViewport: getDefaultVirtualViewport(),
    filterResults: defaultFilterResults(),
    ...view,
  };
};

export const getPanesBoundaries = (
  windowX: number,
  windowY: number,
  windowWidth: number,
  windowHeight: number,
  colViewport: Viewport,
  rowViewport: Viewport,
  // viewport: Viewport,
  freezedColsSum: number,
  freezedRowsSum: number,
  sheet: Sheet,
  isRtl: boolean,
  filterResults?: FilterResults
) => {
  const { freezeMinX, freezeMaxX, paneMinX, paneMaxX, unFreezedCi } =
    getHorizontalBounds(
      windowX,
      windowWidth,
      colViewport,
      rowViewport,
      sheet,
      freezedColsSum,
      isRtl
    );

  const { freezeMinY, freezeMaxY, paneMinY, paneMaxY, unFreezedRi } =
    getVerticalBounds(
      windowY,
      windowHeight,
      rowViewport,
      sheet,
      freezedRowsSum,
      filterResults
    );

  const freezeBoundaries: Boundaries = {
    minX: freezeMinX,
    maxX: freezeMaxX,
    minY: freezeMinY,
    maxY: freezeMaxY,
  };

  const paneBoundaries = {
    minX: paneMinX,
    maxX: paneMaxX,
    minY: paneMinY,
    maxY: paneMaxY,
  };

  return {
    freezeBoundaries,
    paneBoundaries,
    unFreezedCi,
    unFreezedRi,
  };
};

export const getVerticalBounds = (
  windowY: number,
  windowHeight: number,
  rowViewport: Viewport,
  sheet: Sheet,
  freezedRowsSum: number,
  filterResults?: FilterResults
) => {
  const { dynamicTopSection, topSection, bottomSection, freezedRows, zoom } =
    sheet;

  //TODO: Add group bar height
  const colGroupBarHeight = rowViewport.alternateEntityGroupBarSize;

  const dynamictop =
    (colGroupBarHeight + calculateSectionHeightHelper(dynamicTopSection)) *
    sheet.zoom;

  const top = calculateSectionHeightHelper(topSection);
  const freezeMinY = windowY + WindowSizes.controlBarHeight + top + dynamictop;
  const freezeMaxY = freezeMinY + freezedRowsSum;

  const freezeBarSizeY = getFreezeBarHandleSize(freezedRows, zoom);
  freezedRowsSum += freezeBarSizeY;

  const paneMinY = freezeMinY + freezedRowsSum;

  const paneMaxY =
    windowY +
    windowHeight -
    SheetDefaults.statusBarHeight -
    SheetDefaults.scrollBarHeight -
    calculateSectionHeightHelper(bottomSection);

  return {
    freezeMinY,
    freezeMaxY,
    paneMinY,
    paneMaxY,
    unFreezedRi: calcualteFirstNonFrozenIndex(
      sheet.freezedRows,
      sheet.rowSizes,
      sheet.hiddenRows,
      sheet.maxRowIndex,
      rowViewport.frozenIndexes,
      filterResults
    ),
  };
};

export const calcualteFirstNonFrozenIndex = (
  freezed: Freeze,
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  max: number,
  frozenViewportIndexes: number[],
  filterResults?: FilterResults
) => {
  const nonFrozenIndex = freezed.frozen
    ? getUnHiddenPosition(
        entitySizes,
        hiddenRanges,
        freezed.end,
        max,
        DataDirection.Forward,
        freezed,
        filterResults,
        1,
        { useNonFreezeMin: true, frozenViewportIndexes }
      )
    : undefined;

  return nonFrozenIndex;
};

export const getHorizontalBounds = (
  windowX: number,
  windowWidth: number,
  colViewport: Viewport,
  rowViewport: Viewport,
  // viewport: Viewport,
  sheet: Sheet,
  freezedColsSum: number,
  isRtl: boolean
) => {
  const { end: lastRow } = getViewportStartEnd(rowViewport.nonFrozenIndexes);
  // const lastRow = _.last(viewport.nonFrozenIndexes) ?? 0;
  const { leftSection, rightSection, freezedCols, zoom } = sheet;

  const rowGroupBarWidth = colViewport.alternateEntityGroupBarSize;

  const leftOffset =
    getRowHeaderWidth(lastRow, zoom) +
    (rowGroupBarWidth + calculateSectionWidthHelper(leftSection)) * zoom;

  const freezeMinX = isRtl
    ? windowX + windowWidth - leftOffset - freezedColsSum
    : windowX + leftOffset;

  const rightOffset =
    calculateSectionWidthHelper(rightSection) + SheetDefaults.scrollBarWidth;

  const freezeMaxX = freezeMinX + freezedColsSum;

  const freezeBarSizeX = getFreezeBarHandleSize(freezedCols, zoom);
  freezedColsSum += freezeBarSizeX;

  const paneMinX = isRtl ? windowX + rightOffset : freezeMinX + freezedColsSum;
  const paneMaxX = isRtl
    ? freezeMinX - freezeBarSizeX
    : windowX + windowWidth - rightOffset;

  return {
    freezeMinX,
    freezeMaxX,
    paneMinX,
    paneMaxX,
    unFreezedCi: calcualteFirstNonFrozenIndex(
      sheet.freezedCols,
      sheet.colSizes,
      sheet.hiddenCols,
      sheet.maxColIndex,
      colViewport.frozenIndexes
    ),
  };
};
